import { toast } from "react-toastify";

export const hideOverlay = () => {
    let overlay: any = document.querySelector('.overlay-out');
    if(overlay) {
        overlay.style.display = 'none';
    }
}

export const showOverlay = () => {
    let iDiv = document.createElement('div');
    iDiv.className = 'overlay-out';
    let d: any = document;
    if(!document.querySelector('.overlay-out')) {
        d.querySelector('.App').appendChild(iDiv);
    }
}

export const addToBasket = (item: any, toastId: any, addedItemWarning: string, addedItemSuccess: string) => {
    const cartObject = localStorage.getItem('cartObject');
    const id = item.id;
    
    let basket;
    if(cartObject) {
        basket = {...JSON.parse(cartObject)};
        let cartItems = [...basket.items];
        // order once only...
        const items = cartItems.filter(cA => cA.id === id);
        const itemExists = items.length > 0;
        if(itemExists) {
            console.log(123123);
            setTimeout(() => {
                if(!toast.isActive(toastId.current) && !document.getElementById('warning1')) {
                    toastId.current = toast.warn(addedItemWarning, {
                        toastId: 'warning1'
                    });
                }
            }, 100);
        }
        else {
            // TODO: 
            cartItems.push({
                title: item.name,
                id: id,
                imgSrc: item.imageUrl
            });
            basket.items = cartItems;
            setTimeout(() => {
                toast.success(addedItemSuccess, {
                    toastId: 'success1'
                });
            }, 100);
        }
    }
    else {
        basket = {
            items: [
                {
                    title: item.name,
                    id: id,
                    imgSrc: item.imageUrl
                }
            ]
        };
        toast.success(addedItemSuccess);
    }
    localStorage.setItem('cartObject', JSON.stringify(basket));
}